import { useState } from 'react'
import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button-group'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'

interface GenericInputProps {
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
  label: string
}

const GenericInput = ({ onBlur, label }: GenericInputProps) => {
  const [value, setValue] = useState('')
  return (
    <FormControl label={label}>
      {/* @ts-expect-error SDInput is a JS component without proper TS types */}
      <SDInput size={SIZE.compact} value={value} onBlur={onBlur} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value)} />
    </FormControl>
  )
}

export default GenericInput
